import { Link } from "react-router-dom";
import styled from "styled-components";

import {
  palette,
  modularScale,
  pxToRem,
  borderRadius,
} from "@otta/design-tokens";
import { media } from "@otta/design";

const Container = styled(Link)`
  background: ${palette.grayscale.shade100};
  padding: ${modularScale()};
  border-radius: ${pxToRem(borderRadius)};
  color: ${palette.brand.black};
  font-weight: 700;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &:hover {
    background: ${palette.grayscale.shade200};
  }

  ${media({ from: "tablet" })`
    max-width: ${pxToRem(110)};
  `}
`;

export const ViewAllJobs = ({ total }: { total: number }) => (
  <Container to="jobs">View {total} more jobs</Container>
);
